import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss']
})

export class TagComponent implements OnInit {

  @Input() disabled: false;
  @Input() tagName: string = '';
  @Input() abbrName: string = '';
  @Input() backGroundColor: string = '';
  @Input() foreGroundColor: string = '';
  @Input() isRemove: boolean = false;
  @Input() isSearch: boolean = false;
  @Input() displayAbbr: boolean = false;
  @Output() tagRemoved: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  remove(): void{
    if(!this.disabled)
      this.tagRemoved.emit(true);
  }
}
